import { z } from 'my-zod'
import { waiverEmailParametersModel } from './waiver-email-parameters-model'

export const waiverEmailParametersSystemView = waiverEmailParametersModel.augment({
  customerOrderShortId: z.string().nullable()
})
export type waiverEmailParametersSystemView = z.infer<typeof waiverEmailParametersSystemView>
